export const SET_RESULT_ADDRESS = "SET_RESULT_ADDRESS";
export const SET_RESULT_PHONE = "SET_RESULT_PHONE";
export const SET_RESULT_EMAIL = "SET_RESULT_EMAIL";
export const SET_RESULT_WEBSITE = "SET_RESULT_WEBSITE";
export const SET_RESULT = "SET_RESULT";